import React from "react";
import { gql, graphql } from "react-apollo";

import {
  Tabs,
  Loading,
  Grid,
  Notifications,
  Segment,
  Chart
} from "components/UI";

function handleLineClick(id, history) {
  history.push(`/lines/${id}`);
}

function handleFloorClick(id, history) {
  history.push(`/floors/${id}`);
}

function handleUnitClick(id, history) {
  history.push(`/units/${id}`);
}

const BuildingCharts = ({
  onFloorClick,
  onLineClick,
  buildingId,
  history,
  data
}) => {
  const { error, loading, building } = data;

  if (error) return <Notifications.Error message={error.message} />;

  const unitData = loading
    ? []
    : building.units.map(unit => ({
      id: unit.id,
      name: unit.name,
      room: unit.latestRoom,
      radiator: unit.latestRadiator
    }));

  return (
    <Grid.Row>
      <Grid.Col>
        <Segment centered>
          {loading ? (
            <Loading />
          ) : (
              <Chart.DoubleBar
                title="Unit Temperatures"
                data={unitData}
                dataKey1="radiator"
                dataKey2="room"
                colorKey="room"
                onItemClick={id => handleUnitClick(id, history)}
              />
            )}
        </Segment>
      </Grid.Col>
      <Grid.Col>
        <Tabs
          panes={[
            {
              title: "Floor view",
              onClick: onFloorClick,
              content: (
                <Segment centered>
                  {loading ? (
                    <Loading />
                  ) : (
                      <Chart.TemperatureBar
                        title="Floor Temperatures"
                        data={building.floors}
                        // .filter(f => {
                        //   let active = false;
                        //   for (let c of f.covers) {
                        //     if (c.active === true) active = true;
                        //   }
                        //   return active;
                        // })
                        // .filter(f => f.covers.length > 0)}
                        dataKey="temp"
                        onItemClick={id => handleFloorClick(id, history)}
                        scrollable
                      />
                    )}
                </Segment>
              )
            },
            {
              title: "Line view",
              onClick: onLineClick,
              content: (
                <Segment centered>
                  {loading ? (
                    <Loading />
                  ) : (
                      <Chart.TemperatureBar
                        title="Line Temperatures"
                        data={building.lines}
                        // .filter(l => {
                        //   let active = false;
                        //   for (let c of l.covers) {
                        //     if (c.active === true) active = true;
                        //   }
                        //   return active;
                        // })
                        // .filter(l => l.covers.length > 0)}
                        dataKey="temp"
                        onItemClick={id => handleLineClick(id, history)}
                        scrollable
                      />
                    )}
                </Segment>
              )
            }
          ]}
        />
      </Grid.Col>
    </Grid.Row>
  );
};

const BuildingChartsQuery = gql`
  query BuildingChartsQuery($id: Int!) {
    building(id: $id) {
      floors {
        id
        name
        temp
      }
      lines {
        id
        name
        temp
      }
      units {
        id
        name
        temp
        latestRoom
        latestRadiator
      }
    }
  }
`;
export default graphql(BuildingChartsQuery, {
  options: ({ buildingId, from, to }) => ({
    variables: {
      id: buildingId
    },
    notifyOnNetworkStatusChange: true
  })
})(BuildingCharts);



// WEBPACK FOOTER //
// ./src/components/Building/BuildingCharts.jsx